module.exports = __webpack_public_path__ + "static/media/workFromYourComfort.a6d629bc.svg";